import { render } from "./SetPassword.vue?vue&type=template&id=456a3c32&ts=true"
import script from "./SetPassword.vue?vue&type=script&lang=ts"
export * from "./SetPassword.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1111083459/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__